export var RETRY_MODES;
(function (RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})(RETRY_MODES || (RETRY_MODES = {}));
export const DEFAULT_MAX_ATTEMPTS = 3;
export const DEFAULT_RETRY_MODE = "STANDARD";
